import { EAuthRoutes } from '../shared/constants/constants';
import { withQueryParams } from '../shared/functions';
import {
  setAuthorizationToken,
} from '../shared/utils/setAuthorizationToken';
import { getAuthToken } from './authHelpers';

export interface ISubscriptionState {
  product: CdvPurchase.Product | null;
  receipt: CdvPurchase.Receipt | CdvPurchase.AppleAppStore.SKApplicationReceipt | CdvPurchase.GooglePlay.Receipt | null | any;
  transaction: CdvPurchase.Transaction | null;
  verifiedReceipt: CdvPurchase.VerifiedReceipt | null;
  originalTransactionId: string | null;
}

export const storageKey = 'subscription-state';
export const subscriptionName = 'net.hourglass.familycore.subscription';

export const resetSubscriptionState = () => {
  localStorage.removeItem(storageKey);
};

export const getSubscriptionState = () => {
  const DEFAULT_VALUES = {
    product               : null,
    receipt               : null,
    transaction           : null,
    verifiedReceipt       : null,
    originalTransactionId : null,
  };

  const storedData = localStorage.getItem(storageKey);
  const subscription = (storedData ? JSON.parse(storedData) : DEFAULT_VALUES) as ISubscriptionState;

  return subscription;
};

const setSubscriptionState = (subscriptionData: Partial<ISubscriptionState>) => {
  const subscriptionState = getSubscriptionState();
  console.log('subscriptionData: ', subscriptionData);
  console.log('subscriptionState: ', subscriptionState);
  const textarea = window.document.getElementById(
    'app-store-receipt'
  ) as HTMLTextAreaElement;

  if (textarea) {
    const receipt = subscriptionData.transaction?.transactionId
      || subscriptionState.transaction?.transactionId
      || 'Transaction ID is not found';

    textarea.value = JSON.stringify(receipt);
  }

  localStorage.setItem(
    storageKey,
    JSON.stringify({
      ...subscriptionState,
      ...subscriptionData,
    })
  );
};

const onPurchaseSuccess = () => {
  const token = getAuthToken();

  token && setAuthorizationToken(token);

  if (window.location.href.includes(EAuthRoutes.CodeConfirmation)) {
    window.location.href = '/#/';
  }

  if (window.location.href.includes(EAuthRoutes.Checkout)) {
    window.location.href = `/#${withQueryParams(EAuthRoutes.Checkout, {
      purchased: true,
    })}`;
  }
};

// TODO: delete console logs after billing updating deployed without issues
export const checkSubscription = () => {
  if (!window.CdvPurchase) {
    throw new Error('Purchase plugin is not available');
  }

  const { store, Platform, ProductType } = CdvPurchase;

  const appleProduct: CdvPurchase.IRegisterProduct = {
    id       : subscriptionName,
    platform : Platform.APPLE_APPSTORE,
    type     : ProductType.PAID_SUBSCRIPTION,
  };

  const androidProduct: CdvPurchase.IRegisterProduct = {
    id       : subscriptionName,
    platform : Platform.GOOGLE_PLAY,
    type     : ProductType.PAID_SUBSCRIPTION,
  };

  store.error((error) => {
    console.log(`ERROR ${error.code}: ${error.message}`);
  });

  store.register([appleProduct, androidProduct]);
  console.log('[Subscription] store.register called for:', subscriptionName);
  console.log('[Subscription] store.products after register:', JSON.stringify(store.products));

  store
    .when()
    .productUpdated((product) => {
      console.log('PRODUCT, productUpdated', product);
      setSubscriptionState({ product });
    });

  store
    .when()
    .receiptUpdated((receipt) => {
      console.log('RECEIPT receiptUpdated', receipt);
      setSubscriptionState({ receipt });
    }
    );

  store.when().approved((transaction) => {
    console.log('[Subscription] APPROVED — transactionId:', transaction.transactionId, '| products:', JSON.stringify(transaction.products));
    const isOurProduct = transaction.products?.some(p => p.id === subscriptionName);
    console.log('[Subscription] APPROVED — isOurProduct:', isOurProduct);
    if (isOurProduct) {
      const originalTransactionId = (transaction as CdvPurchase.AppleAppStore.SKTransaction)?.originalTransactionId ?? null;
      console.log('[Subscription] APPROVED — originalTransactionId:', originalTransactionId);
      setSubscriptionState({ transaction, originalTransactionId });
    }
    console.log('[Subscription] APPROVED — calling transaction.verify()...');
    transaction.verify();
  });

  store.when().unverified(({ payload }) => {
    console.warn(`[Subscription] UNVERIFIED — Code: ${payload.code} | Status: ${payload.status} | Message: ${payload.message}`);
  });

  store.when().verified((verifiedReceipt) => {
    const owned = store.owned(subscriptionName);
    console.log(`[Subscription] VERIFIED — id: ${verifiedReceipt.id} | owned: ${owned}`);
    console.log('[Subscription] VERIFIED — verifiedReceipt:', JSON.stringify(verifiedReceipt));

    setSubscriptionState({ verifiedReceipt });

    if (owned) {
      console.log('[Subscription] VERIFIED — store.owned is true, calling onPurchaseSuccess()');
      onPurchaseSuccess();
    } else {
      console.warn('[Subscription] VERIFIED — store.owned is false, onPurchaseSuccess() NOT called');
    }

    console.log('[Subscription] VERIFIED — calling verifiedReceipt.finish()...');
    verifiedReceipt.finish();
  });

  store.when().finished((transaction) => {
    console.log('[Subscription] FINISHED — transactionId:', transaction.transactionId, '| state:', transaction.state);
  });

  // https://github.com/j3k0/cordova-plugin-purchase/wiki/HOWTO:-Migrate-to-v13#storerefresh-is-now-storeinitialize-and-co
  store.initialize().then((errors) => {
    console.log('[Subscription] store.initialize() completed. Errors:', JSON.stringify(errors));
    console.log('[Subscription] store.products after initialize:', JSON.stringify(store.products));
  });
};
